/**
   * Dashboard - Home pagina
   */

  import { useEffect, useState } from 'react';
  import { useNavigate } from 'react-router-dom';
  import { authService } from '../services/auth.service';
  import { useAuth } from '../context/AuthContext';
  import OCRScanner from '../components/OCRScanner';

  const Dashboard = () => {
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [showScanner, setShowScanner] = useState(false);
    const navigate = useNavigate();
    const { user: authUser } = useAuth();

    // Debug: Log current user info
    useEffect(() => {
      if (authUser) {
        // User loaded from auth context
      }
    }, [authUser]);

    useEffect(() => {
      loadUser();
    }, []);

    const loadUser = async () => {
      try {
        const currentUser = await authService.getCurrentUser();
        setUser(currentUser);
      } catch (err: any) {
        // Silently fail - user will see login button if not authenticated
        // This is expected behavior for non-logged in users
      } finally {
        setLoading(false);
      }
    };

    if (loading) {
      return <div className="loading">Laden...</div>;
    }

    return (
      <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
        <h1>Welkom bij Buro42</h1>
        {user && (
          <p>Ingelogd als: <strong>{user.username}</strong> ({user.email})</p>
        )}

        <div className="dashboard-grid" style={{ marginTop: '2rem', display: 'grid', gap: '1rem', gridTemplateColumns:
  'repeat(auto-fit, minmax(250px, 1fr))' }}>
          <div className="dashboard-card" onClick={() => navigate('/relations')}>
            <h3>Relaties</h3>
            <p>Beheer klanten en leveranciers</p>
          </div>

          <div className="dashboard-card" onClick={() => navigate('/boten')}>
            <h3>Boten</h3>
            <p>Beheer boten en boot modellen</p>
          </div>

          <div className="dashboard-card" onClick={() => navigate('/voorraad')}>
            <h3>Producten</h3>
            <p>Beheer producten en materialen</p>
          </div>

          <div className="dashboard-card" onClick={() => navigate('/werkorders')}>
            <h3>Werkorders</h3>
            <p>Beheer werkorders en onderhoud</p>
          </div>

          <div className="dashboard-card" onClick={() => navigate('/urenregistratie')}>
            <h3>Urenregistratie</h3>
            <p>Registreer gewerkte uren</p>
          </div>

          <div className="dashboard-card" onClick={() => setShowScanner(true)}>
            <h3>Scan</h3>
            <p>Scan voorraad producten</p>
          </div>

          <div className="dashboard-card" onClick={() => navigate('/boekhouding/scan?type=inkoop')}>
            <h3>Scan Inkoop</h3>
            <p>Scan inkoopfacturen met AI</p>
          </div>

          <div className="dashboard-card" onClick={() => navigate('/boekhouding')}>
            <h3>Boekhouding</h3>
            <p>Financiële administratie</p>
          </div>
        </div>

        {showScanner && (
          <OCRScanner
            onTextScanned={(text) => {
              navigate(`/voorraad?zoek=${encodeURIComponent(text)}`);
            }}
            onClose={() => setShowScanner(false)}
          />
        )}

        <style>{`
          .dashboard-card {
            background: white;
            padding: 1.5rem;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            cursor: pointer;
            transition: transform 0.2s, box-shadow 0.2s;
          }

          .dashboard-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          }

          .dashboard-card h3 {
            margin: 0 0 0.5rem 0;
            color: #1a1a1a;
          }

          .dashboard-card p {
            margin: 0;
            color: #666;
          }

          .dashboard-card small {
            color: #999;
            font-size: 0.75rem;
          }

          @media (max-width: 900px) {
            .dashboard-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}</style>
      </div>
    );
  };

  export default Dashboard;
